import { Check } from "lucide-react";

export const Tick = ({ checked, label, hint, onToggle, disabled, testid }) => (
  <div
    role="button"
    tabIndex={disabled ? -1 : 0}
    aria-disabled={disabled}
    onClick={() => !disabled && onToggle()}
    onKeyDown={(e) => { if (!disabled && (e.key === "Enter" || e.key === " ")) { e.preventDefault(); onToggle(); } }}
    data-testid={testid}
    data-state={checked ? "checked" : "unchecked"}
    className={`flex items-start gap-3 rounded-xl border p-3 transition-colors ${
      disabled ? "cursor-not-allowed border-gray-200 bg-gray-50 opacity-60" : checked ? "cursor-pointer border-oath-accent bg-oath-accent-light" : "cursor-pointer border-gray-200 bg-white hover:border-gray-300"
    }`}
  >
    <span className={`mt-0.5 grid h-4 w-4 shrink-0 place-items-center rounded border ${checked ? "border-oath-accent bg-oath-accent text-white" : "border-gray-300 bg-white"}`}>
      {checked && <Check className="h-3 w-3" strokeWidth={3} />}
    </span>
    <span>
      <span className="block text-sm font-medium text-oath-ink">{label}</span>
      {hint && <span className="mt-0.5 block text-xs text-oath-secondary">{hint}</span>}
    </span>
  </div>
);

export default Tick;
